import { smartSearchConstants } from "../constants";
import { fileService, documentService } from "../services";
//import { loaderMaskActions } from './';
import { handleErrors } from "../../utils";

export const smartSearchActions = {
  setCustomersFilteredByName,
  setCustomersFilteredByUserName,
  setCustomersFilteredByProjectName,
  setCustomersFilteredBySender,

  getFilteredDocsbyEBID,
  getFilteredDocs,
  getFilteredDocsSender,
  getFilteredDocsSenderName,
  getFilteredDocsReceiver,
  getFilteredDocsReceiverName,
  getFilteredFiles,
  getFilteredFilesByCustomerId,

  setFilteredChannels,

  getFilteredBatches
};

function getFilteredBatches(params) {
  return dispatch => {
    dispatch(request());
    documentService.getAllBatchs(params).then(
      data => {
        dispatch(success(data.Data, data.TotalCount > 2));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: smartSearchConstants.GET_BATCHES_REQUEST };
  }
  function success(data, showMore) {
    return { type: smartSearchConstants.GET_BATCHES_SUCCESS, data, showMore };
  }
  function failure(error) {
    return { type: smartSearchConstants.GET_BATCHES_FAILURE, error };
  }
}

function getFilteredFiles(params) {
  return dispatch => {
    dispatch(request());
    fileService.getAll(params).then(
      data => {
        dispatch(success(data.Data, data.TotalCount > 2));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: smartSearchConstants.GET_FILES_REQUEST };
  }
  function success(data, showMore) {
    return { type: smartSearchConstants.GET_FILES_SUCCESS, data, showMore };
  }
  function failure(error) {
    return { type: smartSearchConstants.GET_FILES_FAILURE, error };
  }
}

function getFilteredFilesByCustomerId(params) {
  return dispatch => {
    dispatch(request());
    fileService.getAll(params).then(
      data => {
        dispatch(success(data.Data, data.TotalCount > 2));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: smartSearchConstants.GET_FILES_CUSTOMER_REQUEST };
  }
  function success(data, showMore) {
    return {
      type: smartSearchConstants.GET_FILES_CUSTOMER_SUCCESS,
      data,
      showMore
    };
  }
  function failure(error) {
    return { type: smartSearchConstants.GET_FILES_CUSTOMER_FAILURE, error };
  }
}

function getFilteredDocs(params) {
  return dispatch => {
    dispatch(request());
    documentService.getAll(params).then(
      data => {
        dispatch(success(data.Data.documents, data.TotalCount > 2));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: smartSearchConstants.GET_DOCS_REQUEST };
  }
  function success(data, showMore) {
    return { type: smartSearchConstants.GET_DOCS_SUCCESS, data, showMore };
  }
  function failure(error) {
    return { type: smartSearchConstants.GET_DOCS_FAILURE, error };
  }
}

function getFilteredDocsSender(params) {
  return dispatch => {
    dispatch(request());
    documentService.getAll(params).then(
      data => {
        dispatch(success(data.Data.documents, data.TotalCount > 2));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: smartSearchConstants.GET_DOCS_SENDER_REQUEST };
  }
  function success(data, showMore) {
    return {
      type: smartSearchConstants.GET_DOCS_SENDER_SUCCESS,
      data,
      showMore
    };
  }
  function failure(error) {
    return { type: smartSearchConstants.GET_DOCS_SENDER_FAILURE, error };
  }
}

function getFilteredDocsSenderName(params) {
  return dispatch => {
    dispatch(request());
    documentService.getAll(params).then(
      data => {
        dispatch(success(data.Data.documents, data.TotalCount > 2));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: smartSearchConstants.GET_DOCS_SENDER_NAME_REQUEST };
  }
  function success(data, showMore) {
    return {
      type: smartSearchConstants.GET_DOCS_SENDER_NAME_SUCCESS,
      data,
      showMore
    };
  }
  function failure(error) {
    return { type: smartSearchConstants.GET_DOCS_SENDER_FAILURE, error };
  }
}

function getFilteredDocsReceiver(params) {
  return dispatch => {
    dispatch(request());
    documentService.getAll(params).then(
      data => {
        dispatch(success(data.Data.documents, data.TotalCount > 2));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: smartSearchConstants.GET_DOCS_RECEIVER_REQUEST };
  }
  function success(data, showMore) {
    return {
      type: smartSearchConstants.GET_DOCS_RECEIVER_SUCCESS,
      data,
      showMore
    };
  }
  function failure(error) {
    return { type: smartSearchConstants.GET_DOCS_RECEIVER_FAILURE, error };
  }
}

function getFilteredDocsReceiverName(params) {
  return dispatch => {
    dispatch(request());
    documentService.getAll(params).then(
      data => {
        dispatch(success(data.Data.documents, data.TotalCount > 2));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: smartSearchConstants.GET_DOCS_RECEIVER_NAME_REQUEST };
  }
  function success(data, showMore) {
    return {
      type: smartSearchConstants.GET_DOCS_RECEIVER_NAME_SUCCESS,
      data,
      showMore
    };
  }
  function failure(error) {
    return { type: smartSearchConstants.GET_DOCS_RECEIVER_FAILURE, error };
  }
}

function getFilteredDocsbyEBID(params, byEBID, SearchText) {
  return dispatch => {
    dispatch(request(byEBID, SearchText));
    documentService.getAll(params).then(
      data => {
        dispatch(success(data.Data.documents, byEBID));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
      }
    );
  };

  function request(byEBID, SearchText) {
    return {
      type: smartSearchConstants.GET_DOCS_EBID_REQUEST,
      byEBID,
      SearchText
    };
  }
  function success(data, byEBID) {
    return { type: smartSearchConstants.GET_DOCS_EBID_SUCCESS, data, byEBID };
  }
  function failure(error) {
    return { type: smartSearchConstants.GET_DOCS_EBID_FAILURE, error };
  }
}

function setCustomersFilteredByName(customers) {
  return {
    type: smartSearchConstants.GET_CUSTOMERS_FILTERED_BY_NAME,
    customers
  };
}
function setCustomersFilteredByUserName(customers) {
  return {
    type: smartSearchConstants.GET_CUSTOMERS_FILTERED_BY_USERNAME,
    customers
  };
}
function setFilteredChannels(channels) {
  return {
    type: smartSearchConstants.GET_FILTERED_CHANNELS,
    channels
  };
}
function setCustomersFilteredByProjectName(customers) {
  return {
    type: smartSearchConstants.GET_CUSTOMERS_FILTERED_BY_PROJECTNAME,
    customers
  };
}
function setCustomersFilteredBySender(customers) {
  return {
    type: smartSearchConstants.GET_CUSTOMERS_FILTERED_BY_SENDER,
    customers
  };
}
